import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip } from 'react-tooltip'
import Sidenavbar from '../../Components/Sidenavbar/Sidenavbar';
import UserMenu from '../../Components/UserMenu/UserMenu';
import Paginator from '../../Components/Paginator/Paginator';
import ArcaPrueba from '../../Images/ArcaPrueba.pdf'
import FileUpload from '../../Components/FileUpload/FileUpload';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchData, postData, putData } from '../../Services/apiService';


const ViewDocument = () => {
  const { idFile } = useParams();
  const userType = 'admin';
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const navigate = useNavigate();
  const [fileB64, setfileB64] = useState('');

  
  const handleGoBack = () => {
    navigate(-2);
  };

  useEffect(() => {
    fetchRequestsData();
  }, []);
  const fetchRequestsData = async () => {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const idUser = user.id || 0;
    try {
      const data = await fetchData(`File/${idFile}`);
      if (data.succes){
        setfileB64(data.data.content);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
     
    }
  };

  const resolveAfter2Seconds = new Promise(resolve => setTimeout(resolve, 2000))
  const trainingCompleted = () => toast.promise(resolveAfter2Seconds, {
    pending: "Realizando reentrenamiento",
    success: "Reentrenamiento realizado",
    error: "Error en el reentrenamiento, vuelva a intentar",
  }, {
    position: "top-center",
    autoClose: true,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    });


    const documentAcepted = () => toast.success('Documento aprobado', {
    position: "top-center",
    autoClose: true,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    });

    const documentRejected = () => toast.error('Documento rechazado', {
    position: "top-center",
    autoClose: true,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    className: 'Toastify__toast -danger',
    });
    const handleDocumentStatus = async (status) => {
     
      try {
        const requestData =  {
          id: parseInt(idFile),
          status: status 
        };
        const requestDataJSON = JSON.stringify(requestData);
        const response = await putData(`File/`, requestDataJSON);
    
        if (response.succes) {
          if (status === 'Approved') {
            localStorage.setItem('toastMessage', 'Documento aprobado');
        window.location.href = '/AdminDocuments';
          } else {
            localStorage.setItem('toastMessage', 'Documento rechazado');
        window.location.href = '/AdminDocuments';
          }
        } else {
          toast.error('Error al actualizar el estado del documento', {
            position: "top-center",
            theme: "dark",
          });
        }
      } catch (error) {
        toast.error('No se pudo actualizar el estado', {
          position: "top-center",
          theme: "dark",
        });
      }
    };

  return (
    <div className="container-fluid px-0 m-0 d-flex flex-column flex-md-row">
      <Sidenavbar userType={userType} />
      <div className="container-fluid px-16">
        <UserMenu userType="admin" />
        <ToastContainer />

        <Modal
          size="lg"
          show={show}
          onHide={() => setShow(false)}
          aria-labelledby="modal-change-request-status"
        >
          <button className="btn -icon button-close" onClick={handleClose}>
            <i class="fa-solid fa-xmark"></i>
          </button>
          <Modal.Header className="justify-content-center">
            <Modal.Title>Error al subir documento</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col">
                <p className="body-2">
                  Hubo un error al subir algunos documentos, regresa y súbelos nuevamente o continua sin agregar.
                </p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row justify-content-center mt-40">
              <div className="col-12 col-md-6 col-lg-4">
                <button className="btn -secondary" onClick={handleClose}>
                  Regresar
                </button>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <button className="btn -primary" onClick={handleClose}>
                  Continuar
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>


        {/* See document */}
        <>
          <div className="row mt-40">
            <div className="col-12 col-md-6 col-lg-3">
              
                <button className="btn -text" onClick={handleGoBack}>
                  <i class="fa-solid fa-arrow-left"></i> Regresar
                </button>
              
            </div>
          </div>
          <div className="row mt-24">
            <div className="col-12 col-lg-8">
              {/* <iframe className="w-100 h-100vh" src={ArcaPrueba} frameborder="0" /> */}
              <iframe 
                className="w-100 h-100vh" 
                src={`data:application/pdf;base64,${fileB64}`} 
                frameBorder="0" 
              />
            </div>
            <div className="col-12 col-lg-4 mt-lg-24">
              <div className="row">
                <div className="col-12">
                
                    <button className="btn -primary" onClick={() => handleDocumentStatus('Approved')}>
                      <i class="fa-solid fa-check"></i> Aprobar documento
                    </button>
                 
                </div>
                <div className="col-12 mt-16">
                    <button className="btn -secondary" onClick={() => handleDocumentStatus('Rejected')}>
                      <i class="fa-solid fa-xmark"></i> Rechazar documento
                    </button>
                </div>
              </div>
            </div>
          </div>
        </>
        {/* See document */}

      </div>
    </div>
  );
}

export default ViewDocument;